import { Rate } from "../../margin/objects/rate";
import { Column } from "../objects/column";
import { MarginListCriteria } from "../objects/marginListCriteria";
import { Network } from "../objects/network";
import { NetworkErrors } from "../objects/networkErrors";
import { NetworkListConfiguration } from "../objects/networkListConfiguration";
import { NetworkListCriteria } from "../objects/networkListCriteria";
import { NetworkListFiltersCriteria } from "../objects/networkListFiltersCriteria";
import { DEFAULT_NETWORK_QUOTATION_INCLUDED_PERMISSION } from "../../quotationIncludedPermission/objects/quotationIncludedPermission";


export const NETWORK_MODULE = 'NETWORK_MODULE_AGENCY';
export const NETWORK_MARGIN_MODULE = 'NETWORK_MARGIN';
export const NETWORK_INFO_ROUTE = '/network/edit/:id/info';

export const EMPTY_NETWORK: Network = {
    name: "",
    street: "",
    zip_code: "",
    country: null,
    city: "",
    external_code: "",
    network_key: "",
    logo: null,
    id: -1,
    payment_center: [],
    last_author: null,
    modified_date: null,
    creator: null,
    created_date: null,
    parent: null,
    due_date: null,
    linked_margins: [],
    quotation_default_price_by_product: false,
    can_edit_quotation_included: DEFAULT_NETWORK_QUOTATION_INCLUDED_PERMISSION,
};

export const EMPTY_NETWORK_ERRORS: NetworkErrors = {
    name_error: ""
};


export const EMPTY_NETWORK_FILTERS: NetworkListFiltersCriteria = {
    name: '',
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_NETWORK_LIST_CRITERIA: NetworkListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_NETWORK_FILTERS,
    search: ''
};

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'commission',
    field_name: 'COMMISSION',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'external-code',
    field_name: 'EXTERNAL_CODE',
    checked: true,
    order_by: 'external_code',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'network-key',
    field_name: 'NETWORK_KEY',
    checked: true,
    order_by: 'network_key',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_NETWORK_LIST_CONFIGURATION: NetworkListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};


export const EMPTY_NETWORK_MARGIN_LIST_CRITERIA: MarginListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    // filters: EMPTY_NETWORK_FILTERS,
    search: ''
};
export const MARGIN_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'content-types',
        field_name: 'CONTENT_TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'margin-type',
        field_name: 'MARGIN_TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'commission',
        field_name: 'COMMISSION',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'currency',
        field_name: 'CURRENCY',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: false,
        order_by: 'start_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: false,
        order_by: 'end_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'activated',
        field_name: 'ACTIVATED',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }
];

export const EMPTY_NETWORK_MARGIN_LIST_CONFIGURATION: NetworkListConfiguration = {
    columns: MARGIN_COLUMN,
    preferences: []
};

export const EMPTY_RATE: Rate = {
    applied_under: null,
    currency: null,
    rate: 0,
    rate_type: 'FIX'
};